import { ReactElement } from 'react';

import { CSSObject, Box, Fade } from '@mui/material';

import { AnimatePresence } from 'framer-motion';

import { ImageProps } from './types';

import { useBoolean } from '../../common/hooks';

export default function Image(props: ImageProps): ReactElement {
  const { alt, thumbnailSrc, fullSrc, borderRadius = 0, onError, onLoad } = props;

  const [isFullError, setIsFullError] = useBoolean(true);

  const [isThumbnailLoaded, setIsThumbnailLoaded] = useBoolean();
  const [isThumbnailError, setIsThumbnailError] = useBoolean();

  const style: CSSObject = {
    width: '100%',
    height: '100%',
    borderRadius,
    position: 'absolute'
  };

  return (
    <AnimatePresence exitBeforeEnter initial={false}>
      <Box position='relative' sx={{ ...style }}>
        {/* Thumbnail image */}
        <Box component={Fade} in={!isThumbnailError} sx={{ ...style }}>
          <img
            alt={`${alt} thumbnail`}
            onError={(error) => {
              setIsThumbnailLoaded.off();
              setIsThumbnailError.on();

              if (onError) {
                onError(error);
              }
            }}
            onLoad={(event) => {
              setIsThumbnailLoaded.on();
              setIsThumbnailError.off();

              setIsFullError.off();

              if (onLoad) {
                onLoad(event);
              }
            }}
            src={thumbnailSrc}
            style={{ ...style, objectFit: 'cover' }}
          />
        </Box>

        {/* Full size image */}
        <Box component={Fade} in={!isFullError && isThumbnailLoaded} sx={{ ...style }}>
          <img
            alt={alt}
            onError={(error) => {
              setIsFullError.on();

              if (onError) {
                onError(error);
              }
            }}
            onLoad={(event) => {
              setIsFullError.off();

              if (onLoad) {
                onLoad(event);
              }
            }}
            src={fullSrc}
            style={{ ...style, objectFit: 'cover' }}
          />
        </Box>
      </Box>
    </AnimatePresence>
  );
}
